// extracted by mini-css-extract-plugin
export default {"svg":"button-undo_svg__VxWJt"};